module.exports = new __parcel__URL__("incidents.c1cdd3ac.svg").toString();